module.exports = __webpack_public_path__ + "static/Metropolis-Bold-168e1781ba479b684da20cf914def2c1.woff";